import React from "react";
import { SwiperSlide } from "swiper/react";

import { sort } from "../../../utilities/helpers";

import { Slider } from "../../Slider";
import { TicketCard } from "../../TicketCard";
import { TransferCard } from "../../TransferCard";

export default function MyEventsSlider({
  navigationNextRef,
  navigationPrevRef,
  orders,
  transfers,
  acceptTransfer,
  isAccepting,
  guestLists,
}) {
  return (
    <div className="page-slider">
      <Slider
        navigationPrevRef={navigationPrevRef}
        navigationNextRef={navigationNextRef}
        addedModule="pagination"
      >
        {transfers &&
          sort(transfers, "event").map((transfer, index) => {
            return (
              <SwiperSlide key={index} className="swiper-lazy">
                <TransferCard
                  transfer={transfer}
                  status={"userAccepting"}
                  isAccepting={isAccepting}
                  acceptTransfer={acceptTransfer}
                />
              </SwiperSlide>
            );
          })}

        {orders &&
          sort(orders, "event").map((o, index) => {
            if (o.tickets.length === 0 && o.event !== null) return;
            return (
              <SwiperSlide key={index} className="swiper-lazy">
                <TicketCard event={o.event} tickets={o.tickets} order={o} />
              </SwiperSlide>
            );
          })}

        {guestLists &&
          sort(guestLists, "event").map((gl, index) => {
            return (
              <SwiperSlide key={index} className="swiper-lazy">
                <TicketCard guestList={gl} />
              </SwiperSlide>
            );
          })}
      </Slider>
    </div>
  );
}
